import "./ProjectCard.module.scss";

import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import {IProjectStats} from "../models";

import Card from "@toolbox/design/Card";
import {
    getAnalyses,
    getButtons,
    getMatches,
    getMeasurements,
    getSops,
    getTitle,
} from "./ProjectView";

interface IProjectCardProps {
    intl: IntlShape;
    project: IProjectStats;
    query: string;
    width: number;
}

class ProjectCard extends React.PureComponent<IProjectCardProps> {
    public render() {
        const {intl, project, query, width} = this.props;
        const {customLogo, id, isHidden, matches, name} = project;
        const renderButtons = () => getButtons(id, intl);
        const className =
            "card-body" +
            (isHidden ? " bg-tertiary" : "") +
            (matches.length ? " d-flex" : "");

        return (
            <Card
                headerClassName="bg-secondary"
                title={getTitle(
                    name,
                    id,
                    query,
                    undefined,
                    matches,
                    customLogo,
                )}
                noMargin={true}
                style={{width}}
                renderButtons={renderButtons}
            >
                <div className={className}>{this.renderBody()}</div>
                <div styleName="project-card-footer" />
            </Card>
        );
    }

    public renderBody() {
        const {project, query} = this.props;
        const {matches} = project;

        if (!matches.length) {
            return this.renderContentOverview();
        }

        return (
            <React.Fragment>
                <span className="col-6">{this.renderContentOverview()}</span>
                <span className="col-6">{getMatches(matches, query)}</span>
            </React.Fragment>
        );
    }

    public renderContentOverview() {
        const {intl, project} = this.props;
        const {analyses, id, measurements, sops} = project;

        return (
            <ul className="list-unstyled">
                <li>{getSops(intl, sops, id)}</li>
                <li>{getMeasurements(intl, measurements, id)}</li>
                <li>{getAnalyses(intl, analyses, id)}</li>
            </ul>
        );
    }
}

export default injectIntl(ProjectCard);
